import React from 'react';
import PropTypes from 'prop-types';

function Request({ size, stroke, strokeWidth, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        d="M8.65 15.5C8.65 15.141 8.35899 14.85 8 14.85C7.64101 14.85 7.35 15.141 7.35 15.5H8.65ZM18.4675 8.35C18.1085 8.35 17.8175 8.64101 17.8175 9C17.8175 9.35899 18.1085 9.65 18.4675 9.65V8.35ZM18.4956 18.8573L18.9182 18.3634L18.4956 18.8573ZM20.835 20.8588L20.4124 21.3527L20.835 20.8588ZM20.35 10V18.8333H21.65V10H20.35ZM20.35 18.8333V20.7828H21.65V18.8333H20.35ZM18.4306 18.1833H9V19.4833H18.4306V18.1833ZM21.2576 20.3649L18.9182 18.3634L18.073 19.3513L20.4124 21.3527L21.2576 20.3649ZM8.65 17.8333V15.5H7.35V17.8333H8.65ZM18.4675 9.65H20V8.35H18.4675V9.65ZM18.4306 19.4833C18.2995 19.4833 18.1727 19.4365 18.073 19.3513L18.9182 18.3634C18.7823 18.2472 18.6094 18.1833 18.4306 18.1833V19.4833ZM20.35 20.7828C20.35 20.3132 20.9007 20.0596 21.2576 20.3649L20.4124 21.3527C20.8991 21.7691 21.65 21.4233 21.65 20.7828H20.35ZM9 18.1833C8.8067 18.1833 8.65 18.0266 8.65 17.8333H7.35C7.35 18.7446 8.08873 19.4833 9 19.4833V18.1833ZM21.65 10C21.65 9.08873 20.9113 8.35 20 8.35V9.65C20.1933 9.65 20.35 9.8067 20.35 10H21.65Z"
        fill={stroke}
      />
      <path
        d="M4 3H15C15.5523 3 16 3.44771 16 4V11.8333C16 12.3856 15.5523 12.8333 15 12.8333H5.56941C5.54557 12.8333 5.52251 12.8418 5.5044 12.8573L3.16501 14.8588C3.10013 14.9143 3 14.8682 3 14.7828V12.8333V4C3 3.44772 3.44772 3 4 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M13 6.5H6.0001" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M13 9.5H6.0001" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  );
}

Request.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Request;
